export default __webpack_public_path__ + "static/media/messenger-site.47266db5.png";